import { render, staticRenderFns } from "./Busbuddy.vue?vue&type=template&id=2e9d6cd4&"
import script from "./Busbuddy.vue?vue&type=script&lang=js&"
export * from "./Busbuddy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports